import { LOCAL_STORAGE_USER } from "../constantsObservacions";

export const guardarToken = token => {
  localStorage.setItem(LOCAL_STORAGE_USER, token);
};

export const eliminarToken = () => {
  localStorage.removeItem(LOCAL_STORAGE_USER);
};

export const obtenirToken = () => localStorage.getItem(LOCAL_STORAGE_USER);
